import { interventionType } from './interventionSelectionConstants';

export const targetTypes = {
  word: 'word', //default
  morpheme: 'morpheme',
}

export const listeningPatterTypes = {
  greatJob: 'greatJob',
  didntHear: 'didntHear',
  giveAnswer: 'giveAnswer',
  thanks: 'thanks',
  moveOn: 'moveOn',
  none: 'none',
};

export const defaultListeningPatter = {
  match: listeningPatterTypes.greatJob,
  silence: listeningPatterTypes.didntHear,
  struggle: listeningPatterTypes.moveOn,
  skip: listeningPatterTypes.moveOn,
};

export const defaultInterventionListenConfig = {
    targetTypes: targetTypes.word,
    targetMatchesGoal: 1,
    patter: defaultListeningPatter,
};

export const interventionListenConfigs = {
  //standard: listening at the end of an intervention
  [interventionType.clap]: defaultInterventionListenConfig,
  [interventionType.lipsync]: defaultInterventionListenConfig,
  [interventionType.phonemeLipsync]: defaultInterventionListenConfig,
  [interventionType.spelloutBefore]: defaultInterventionListenConfig,
  // [interventionType.phonemeGiveWord]: 'phonemeGiveWord',
  [interventionType.simpledefinition]: defaultInterventionListenConfig,
  [interventionType.tense]: defaultInterventionListenConfig,
  [interventionType.funfact]: defaultInterventionListenConfig,
  [interventionType.cognate]: defaultInterventionListenConfig,
  [interventionType.rhyme]: {
    ...defaultInterventionListenConfig,
    patter: {
      ...defaultListeningPatter,
      skip: listeningPatterTypes.giveAnswer,
      silence: listeningPatterTypes.giveAnswer,
      struggle: listeningPatterTypes.giveAnswer,
    }
  },
  //non-standard: listening mid-intervention or for something other than a single word
  [interventionType.spellout]: {
    ...defaultInterventionListenConfig,
    patter: {
      match: listeningPatterTypes.greatJob,
      silence: listeningPatterTypes.didntHear,
    }
  },
  [interventionType.sayit]: {
    ...defaultInterventionListenConfig,
    patter: {
      match: listeningPatterTypes.thanks,
      silence: listeningPatterTypes.thanks,
      struggle: listeningPatterTypes.thanks,
      skip: listeningPatterTypes.giveAnswer,
    }
   },
   [interventionType.sight]: {
    ...defaultInterventionListenConfig,
    targetMatchesGoal: 3,
    patter: {
      ...defaultListeningPatter,
      struggle: listeningPatterTypes.thanks,
      skip: listeningPatterTypes.thanks,
    }
   },
   [interventionType.riddle]: {
    ...defaultInterventionListenConfig,
    patter:{
      ...defaultListeningPatter,
      match: listeningPatterTypes.none,
      struggle: listeningPatterTypes.none,
      skip: listeningPatterTypes.none,
    }
  },
  [interventionType.morpheme]: {
    ...defaultInterventionListenConfig,
    patter:{
      ...defaultListeningPatter,
      match: listeningPatterTypes.none,
      struggle: listeningPatterTypes.none,
      skip: listeningPatterTypes.none,
    }
  }
}
